import { Stack, Image, Title, Text, rem } from '@mantine/core';
import GettingStarted from '@assets/get-started.png';

function BannerGetStarted() {
  return (
    <Stack align="center" justify="center" mt="20vh">
      <Title c="white" ta="center">
        Get started!
      </Title>
      <Image w="30%" src={GettingStarted} />
      <Text c="white" ta="center" m={rem(40)}>
        We use this information to build an AI generate company overview which is used to create your OKRs
      </Text>
    </Stack>
  );
}

export { BannerGetStarted };
